import styled from "@emotion/styled";
import theme from "@theme/";

const ChildContainer = styled.div`
  overflow: auto;
  font-size: 13px;
  max-height: calc(100vh - 150px);
  padding: 12px 0 20px 0;
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(5px);
  min-height: 100px;
  display: block;
  visibility: visible;
  opacity: 1;
  margin-bottom: 70px;

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(227, 110, 0, 0.05);
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #e36e00 0%, #ffae00 100%);
    border-radius: 8px;
    transition: all 0.2s ease;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #ffae00 0%, #e36e00 100%);
    box-shadow: 0 2px 8px rgba(227, 110, 0, 0.3);
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

const SC = {
  ChildContainer,
};

export default SC;
